/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import WebhookForm from 'ui/components/organizations/WebhookForm.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

/**
 * This components shows the webhooks list.
 *
 * @vue-prop {Object} organization the organization object
 *
 * @category ui.pages.organizations
 * @exports Webhooks
 * @component
 */
const __vue_script__ = {
    name: 'Webhooks',

    components: { Toggler },

    props: {
        organization: {
            type: Object,
            required: true
        },

        testing: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            learn_more_url: this.$const.KB_SPOTME_WEBHOOKS,
            webhooks: this.organization.webhooks || [],
            error: null
        };
    },

    async created() {
        await this.init();
    },

    methods: {
        /**
         * Initializes the component
         */
        async init() {
            try {
                const { webhooks } = await this.$services.org.getOrg(this.organization.name);

                this.webhooks = webhooks || [];
            } catch (error) {
                this.error = error.message;
            }
        },

        /**
         * Opens the webhook creation form
         */
        create() {
            return this.openEditor('webhooks.actions.create');
        },

        /**
         * Opens the webhook editing form
         *
         * @param {Object} webhook the webhook to edit
         */
        edit(webhook) {
            return this.openEditor('webhooks.actions.edit', webhook);
        },

        /**
         * Prompts the user for webhook removal
         *
         * @param {Object} webhook the webhook to delete
         */
        promptRemoval(webhook) {
            this.$modal.show('dialog', {
                title: this.$i18n.t('general.warning'),
                text: this.$i18n.t('webhooks.actions.prompt_delete'),
                buttons: [
                    {
                        title: this.$i18n.t('general.cancel'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$i18n.t('general.delete'),
                        handler: () => { this.delete(webhook); this.$modal.hide('dialog'); },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        /**
         * Deletes the give webhook from the persisted organization document.
         *
         * @param {Object} webhook the webhook to delete
         */
        async delete(webhook) {
            try {
                await this.$services.org.deleteWebhook(this.organization.name, webhook.id);
                await this.init();

            } catch (error) {
                this.error = error.message;
            }
        },

        /**
         * Opens the webhook editing form
         *
         * @param {String} title the modal title
         * @param {Object} [webhook] the webhook to edit
         */
        openEditor(title, webhook) {
            this.$modal.show(WebhookForm,
                {
                    title: title,
                    organization: this.organization,
                    webhook
                },
                {
                    classes: 'small',
                    height: 'auto',
                    reset: true,
                    clickToClose: false
                },
                {
                    closed: () => this.init()
                }
            );
        },

        /**
         * Toggles webhook active flag
         *
         * @param {Boolean} active the active status
         * @param {Object} webhook the webhook to change the status of
         */
        async toggleActivation(active, webhook) {
            webhook.active = active;

            try {
                await this.$services.org.saveWebhook(this.organization.name, webhook);
            } catch (error) {
                this.error = error.message;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"webhooks-manager"},[_c('i18n',{staticClass:"intro",attrs:{"tag":"p","path":_vm.webhooks.length ? 'webhooks.intro_full' : 'webhooks.intro_empty'}},[_c('a',{attrs:{"href":_vm.learn_more_url}},[_vm._v(_vm._s(_vm.$t('webhooks.intro_full_link_label')))])]),(_vm.webhooks.length && !_vm.error)?_c('div',{staticClass:"objects-list"},_vm._l((_vm.webhooks),function(webhook){return _c('div',{key:webhook.id,staticClass:"object webhook"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.edit(webhook)}}},[_vm._v(_vm._s(_vm.$t('general.edit')))]),_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.promptRemoval(webhook)}}},[_vm._v(_vm._s(_vm.$t('general.delete')))])]),_c('div',{staticClass:"name"},[_vm._v(_vm._s(webhook.label || webhook.url))]),_c('div',{staticClass:"triggers"},[_vm._v(_vm._s(_vm.$utils.strings.humanJoin(webhook.actions)))]),_c('toggler',{attrs:{"name":"active"},on:{"input":function($event){return _vm.toggleActivation($event, webhook)}},model:{value:(webhook.active),callback:function ($$v) {_vm.$set(webhook, "active", $$v)},expression:"webhook.active"}})],1)}),0):_vm._e(),(_vm.error)?_c('div',{staticClass:"webhooks-error"},[_c('h2',[_vm._v(_vm._s(_vm.$t('general.error_occurred')))]),_c('div',{staticClass:"alert alert-error"},[_vm._v(_vm._s(_vm.error))])]):_vm._e(),_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.create}},[_vm._v(_vm._s(_vm.$t('webhooks.actions.create')))])]),(_vm.testing)?_c('v-dialog'):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Webhooks.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__